import axios from "axios";
import authHeader from "./auth_header";
import * as CONST from './common'

const API_URL = CONST.API_URL;
const AUTH_URL = CONST.API_AUTH_URL;
const BASE_URL = CONST.BASE_URL;

const getPublicContent = () => {
    return axios.get(API_URL + "all");
};

const getUserBoard = () => {
    return axios.get(API_URL + "user", { headers: authHeader() });
};

const getModeratorBoard = () => {
    return axios.get(API_URL + "mod", { headers: authHeader() });
};

const getAdminBoard = () => {
    return axios.get(API_URL + "admin", { headers: authHeader() });
};

const getUsersList = (order = 'asc', page = '1', filter_name = '') => {
    return axios.get(API_URL + 'users?order=' + order + '&page=' + page + '&filter=' + filter_name, { headers: authHeader() });
}

const getUserInfo = (user_id) => {
    return axios.get(API_URL + 'users/' + user_id, { headers: authHeader() });
}

const getUsersApps = (user_id, page = 1) => {
    return axios.get(API_URL + 'users/apps?user_id=' + user_id + '&page=' + page, { headers: authHeader() });
}

const getUsersActions = (user_id, page = 1, filter_name = '') => {
    return axios.get(API_URL + 'users/actions?user_id=' + user_id + '&page=' + page + '&filter=' + filter_name, { headers: authHeader() });
}

const getUsersSentMessages = (user_id, page = 1) => {
    return axios.get(API_URL + 'users/messages?user_id=' + user_id + '&page=' + page, { headers: authHeader() });
}

const getUserProfile = () => {
    return axios.get(BASE_URL + 'users/me', { headers: authHeader() })
}

const sendMessageToUser = (user_ids, message) => {
    return axios.post(API_URL + 'send_message', { message: message, user_ids: user_ids }, { headers: authHeader() })
}

const loadUserSubscription = (user_id = '') => {
    if (user_id === '') {
        return axios.get(API_URL + 'users/subscriptions', { headers: authHeader() })
    }
    else {
        return axios.get(API_URL + 'users/subscriptions?user_id=' + user_id, { headers: authHeader() })
    }
}

const getUserSettings = () => {
    return axios.get(API_URL + 'users/user_settings', { headers: authHeader() });
}

const changeUserSettings = (language) => {
    return axios.post(API_URL + 'users/user_settings', { translation_language: language }, { headers: authHeader() });
}


export default {
    getPublicContent,
    getUserBoard,
    getModeratorBoard,
    getAdminBoard,
    getUsersList,
    getUserInfo,
    getUsersApps,
    getUsersActions,
    getUsersSentMessages,
    getUserProfile,
    sendMessageToUser,
    loadUserSubscription,
    getUserSettings,
    changeUserSettings
};